<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header" *ngIf="!vm.success">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<h1 class="c-text c-text--center c-text--heading c-text--xl">{{ 'Feedback.Title' | translate }}</h1>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.handleModalClose()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pb" [ngClass]="{'u-no-pt': vm.success}" [ngSwitch]="vm.success">
			<!-- content: success -->
			<div *ngSwitchCase="true">
				<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/success.svg" alt="">
				<p class="c-text c-text--center c-text--heading c-text--xl">{{ 'Common.Thank_You' | translate }}</p>
				<p class="c-text c-text--center c-text--heading c-text--xl">{{ 'Feedback.Success' | translate }}</p>
				<div class="o-grid o-grid--center-h u-ost-xl">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
						<button id="feedbackModalCloseButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.handleModalClose()">{{ 'Common.Close' | translate }}</button>
					</div>
				</div>
			</div>
			<!-- content: input mode -->
			<div *ngSwitchDefault>
				<div class="o-grid o-grid--center-h">
					<div class="o-grid__cell o-grid__cell--w-fixed">
						<div class="c-thumb">
							<div class="c-image c-image--bg c-image--round c-image--lg u-ost-lg u-osb-lg"
									 [ngStyle]="{ 'background-image': 'url(' + (vm.subject.photoUrl) + ')' }"></div>
						</div>
					</div>
				</div>
				<p class="c-text c-text--center c-text--bold c-text--lg">{{ vm.subject.firstName }} {{ vm.subject.lastName }}</p>
				<p class="c-text c-text--center c-text--gray">{{ 'Common.Patient' | translate }}</p>
				<p class="c-text c-text--center u-ost-lg">{{ 'Feedback.Info_Session' | translate }}</p>
				<form class="c-form u-ost-lg" name="vm.form" novalidate>
					<!-- content: input mode: boolean session helped -->
					<div class="o-grid o-grid--center-h">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-sm">
							<button id="positiveRatingButton" type="button" class="c-button c-button--s6 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md" (click)="vm.handleFormSubmit(true)" style="align-items:center;display: inline-flex;justify-content: center;">
								<img style="width:24px;height:24px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icon_thumbs_up.svg" title="{{'PreVisit.Feedback.Positive' | translate}}" />
							</button>
							<button id="negativeRatingButton" type="button" class="c-button c-button--s6 c-button--lg c-button--fit@up-to-sm" (click)="vm.handleFormSubmit(false)" style="align-items:center;display: inline-flex;justify-content: center;">
								<img style="width:24px;height:24px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icon_thumbs_down.svg" title="{{'PreVisit.Feedback.Negative' | translate}}" />
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
